<template>
  <div class="form-reset-password">
    <div class="form-forgot-password__alert" v-if="error">
      <p class="alerts alerts-errors text-center">
        {{ erroMessage }}
      </p>
    </div>

    <ValidationObserver
      v-slot="ob"
      tag="div"
      class="form-reset-password__form"
      v-if="!success"
    >
      <Form
        novalidate
        :valid="true"
        :loading="loading"
        @submit="ob.handleSubmit(submit)"
      >
        <FormGroup>
          <p class="text-sans-base text-center">
            Inserisci la nuova password per aggiornare il tuo account
          </p>
        </FormGroup>
        <ValidationProvider
          name="Password"
          rules="required|min:8"
          vid="confirmation"
          v-slot="v"
        >
          <FormGroup
            for="form-reset-password-pw"
            label="Password"
            legend="(Minimo 8 caratteri)"
            :vee-errors="v.errors"
          >
            <v-input
              type="password"
              v-model="password"
              id="form-reset-password-pw"
              name="password"
              :disabled="loading"
            />
          </FormGroup>
        </ValidationProvider>
        <ValidationProvider
          name="Conferma Password"
          rules="confirm:@confirmation"
          mode="aggressive"
          v-slot="v"
        >
          <FormGroup
            label="Conferma Password"
            for="fform-reset-password-confirmation"
            :vee-errors="v.errors"
          >
            <v-input
              type="password"
              v-model="confirmPassword"
              id="form-reset-password-confirmation"
              name="password-confirmation"
              :disabled="loading"
            />
          </FormGroup>
        </ValidationProvider>

        <FormSubmit slot="footer" class="p-4" :disabled="loading || !ob.passed"
          >Aggiorna password</FormSubmit
        >
      </Form>
    </ValidationObserver>

    <div class="form-forgot-password__success" v-if="success">
      <p class="text-sans-lg text-center">
        La password è stata aggiornata correttamente.<br />
      </p>
      <p class="text-sans-base text-center mt-4">
        <a :href="`/${$route.params.tenant}/login`" class="font-bold"
          >Effettua il login.</a
        >
      </p>
    </div>
  </div>
</template>

<script>
/** Packages */
import axios from 'axios'

/** Components */
import Form from '@/components/Form.vue'
import FormGroup from '@/components/FormGroup.vue'
import FormSubmit from '@/components/FormSubmit.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    Form,
    FormGroup,
    FormSubmit,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      password: '',
      confirmPassword: '',
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    }
  },

  methods: {
    async submit() {
      this.loading = true
      this.error = false
      this.erroMessage = ''

      try {
        const result = await axios.get('/.netlify/functions/reset-password', {
          params: {
            password: this.password,
            tenant: this.$route.params.tenant,
            token: this.$route.query.token,
          },
        })

        const data = result.data

        if (data && Object.keys(data).length) {
          this.success = true
        }
      } catch (err) {
        console.dir(err)
        this.error = true
        this.erroMessage = 'Non è stato possibile aggiornare la password'
      }

      this.loading = false
    },
  },
}
</script>
